import React, { useState, useEffect } from "react";
import Commonheader from "./Commonheader";
import useAxios from "../hooks/useAxios";
import {
  Modal,
  Form,
  Input,
  Select,
  InputNumber,
  Button,
  Row,
  Col,
} from "antd";
import { EditOutlined, DeleteFilled, PlusOutlined } from "@ant-design/icons";
const { Option } = Select;

function ExecuteServiceConfig(props) {
  const [loading, sendRequest] = useAxios();
  const [isErrOpen, setisErrOpen] = useState(false);
  const [api_error_message, setapi_error_message] = useState();
  const [configs, setConfigs] = useState([]);
  const [config, setConfig] = useState(defaultConfig);

  const [refreshConfig, setRefreshConfig] = useState(true);
  useEffect(() => {
    let apitoken = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/config/executeservice/`,
        method: "GET",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        setConfigs(response);
      }
    );
  }, [refreshConfig]);

  const setError = (error_message) => {
    setisErrOpen(true);
    setapi_error_message(error_message);
  };

  const createConfig = (e) => {
    const allFieldsFilled = Object.values(config).every(
      (value) => value !== ""
    );

    if (!allFieldsFilled) {
      setError("All fields are mandatory!");
      return;
    }

    const _config = {
      db_config: `${config.db_name}.${config.collection_name}`,
      destination_status: config.destination_status
        ? config.destination_status
        : null,
      query_config: `${config.input_key}|${config.derived_key}|${config.type}`,
      status: config.status,
      uri: config.uri,
    };

    console.log(_config);
    let apitoken = localStorage.getItem("api_token");

    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/config/executeservice/`,
        method: "POST",
        headers: {
          "api-token": apitoken,
          "Content-Type": "application/json",
        },
        data: _config,
      },
      (response) => {
        if (response.error) {
          setError(response.error);
          return;
        }
        setRefreshConfig(!refreshConfig);
      }
    );
  };

  const deleteConfig = (config_id) => {
    let apitoken = localStorage.getItem("api_token");

    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/config/executeservice/${config_id}/delete`,
        method: "POST",
        headers: {
          "api-token": apitoken,
          "Content-Type": "application/json",
        },
        data: {},
      },
      (response) => {
        if (response.error) {
          setError(response.error);
          return;
        }
        setRefreshConfig(!refreshConfig);
      }
    );
  };

  const setConfigHandler = (new_config) => {
    setConfig(new_config);
  };

  return (
    <div className="container">
      <Commonheader pagetitle={"View List"} props={props} />
      {loading && (
        <div class="load-4">
          <div class="ring-1"></div>
        </div>
      )}
      <div
        className={
          isErrOpen
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setisErrOpen(false);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="popuperrtext">{api_error_message}</p>
          </div>
        </div>
      </div>

      <ConfigForm
        initialConfig={defaultConfig}
        setError={setError}
        setConfig={setConfigHandler}
      />

      <button className="btn btn-primary" onClick={createConfig}>
        Create Config
      </button>
      <div className="mt-4">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th scope="col">URI</th>
              <th scope="col">Destination Status</th>
              <th scope="col">Query Config</th>
              <th scope="col">DB Config</th>
              <th scope="col">Status</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {configs &&
              configs.map((config) => (
                <tr>
                  <td>{config.uri}</td>
                  <td>{config.destination_status}</td>
                  <td>{config.query_config}</td>
                  <td>{config.db_config}</td>
                  <td>{config.status}</td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-outline-info"
                      onClick={() =>
                        props.history.push({
                          pathname: `executeservice/edit`,
                          state: {
                            config_id: config.id,
                          },
                        })
                      }
                    >
                      <EditOutlined />
                    </button>

                    <button
                      type="button"
                      class="btn btn-outline-info"
                      onClick={() => {
                        deleteConfig(config.id);
                      }}
                    >
                      <DeleteFilled />
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export const defaultConfig = {
  destination_status: "",
  db_name: "",
  collection_name: "",
  input_key: "",
  derived_key: "",
  status: "A",
  uri: "",
  type: "",
};

export const ConfigForm = ({ initialConfig, setConfig }) => {
  const config = { ...initialConfig };

  const [form] = Form.useForm();

  const statusOptions = [
    { option: "Active", value: "A" },
    { option: "Inactive", value: "X" },
  ];

  const datatypeOptions = [
    { option: "String", value: "string" },
    { option: "Int", value: "int" },
  ];

  const valueChangeHandler = (changedValues, allValues) => {
    if (allValues.destination_status == "") allValues.destination_status = null;
    setConfig({ ...config, ...allValues });
  };
  // const db_config = `${db_name}.${collection_name}`;

  // const query_config = `${input_key}|${derived_key}|${datatype}`;

  return (
    config && (
      <Form
        form={form}
        onFinish={() => {
          console.log("submitted");
        }}
        onValuesChange={valueChangeHandler}
        layout="vertical"
      >
        <Row gutter={[24, 16]}>
          <Col span={10}>
            <Form.Item label="URI" name="uri" initialValue={config.uri || ""}>
              <Input placeholder="Enter the URL of the API" />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Status"
              name="status"
              initialValue={config.status || ""}
            >
              <Select>
                {statusOptions.map(({ option, value }) => (
                  <Option key={option} value={value}>
                    {option}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 16]} label="DB Config">
          <Col span={5}>
            <Form.Item
              label="Database Name"
              name="db_name"
              initialValue={config.db_name || ""}
            >
              <Input placeholder="Enter the Database name" />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Collection Name"
              name="collection_name"
              initialValue={config.collection_name || ""}
            >
              <Input placeholder="Enter the Collection name" />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Input Key"
              name="input_key"
              initialValue={config.input_key || ""}
            >
              <Input placeholder="Enter Input Key" />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Destination Status"
              name="destination_status"
              initialValue={config.destination_status || ""}
            >
              <InputNumber />
            </Form.Item>
          </Col>
          <Col span={5} hidden>
            <Form.Item
              label="Derived Key"
              name="derived_key"
              initialValue={"household_id"}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Datatype"
              name="type"
              initialValue={config.type || ""}
            >
              <Select>
                {datatypeOptions.map(({ option, value }) => (
                  <Option key={option} value={value}>
                    {option}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 16]} label="Query Config"></Row>
      </Form>
    )
  );
};
export default ExecuteServiceConfig;
